
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import WhatsAppButton from '../../../components/feature/WhatsAppButton';
import SEOHead from '../../../components/SEO/SEOHead';

export default function Product3Page() {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('overview');

  const seoData = {
    title: 'نخ یووی دار گلخانه | نخ مقاوم UV برای نگهداری گیاهان | گلخانه سبز آریا',
    description: 'نخ گلخانه یووی دار با محافظت ۴ درصد UV - تولید نخ مقاوم برای نگهداری گوجه، خیار و سایر گیاهان گلخانه‌ای - نخ ۲۰۰۰ متری سفید و سبز',
    keywords: 'نخ گلخانه، نخ یووی دار، نخ UV گلخانه، نخ نگهداری گیاه، نخ گوجه فرنگی، نخ خیار، نخ پلی پروپیلن، تجهیزات گلخانه، نخ مقاوم، نخ کشاورزی',
    ogImage: 'https://public.readdy.ai/ai/img_res/417f4b0fe2ad8a1a84c16f72a73ee2c0.jpg',
    structuredData: {
      "@context": "https://schema.org",
      "@type": "Product",
      "name": "نخ یووی دار گلخانه",
      "description": 'نخ گلخانه یووی دار با محافظت ۴ درصد UV - تولید نخ مقاوم برای نگهداری گوجه، خیار و سایر گیاهان گلخانه‌ای - نخ ۲۰۰۰ متری سفید و سبز',
      "url": (import.meta.env.VITE_SITE_URL || 'https://example.com') + "/products/3",
      "brand": {
        "@type": "Brand",
        "name": "گلخانه سبز آریا"
      },
      "manufacturer": {
        "@type": "Organization",
        "name": "آریا گرین هاوس"
      },
      "category": "تجهیزات گلخانه",
      "material": "پلی‌پروپیلن (PP)",
      "color": "سفید، سبز",
      "weight": "۲ کیلوگرم",
      "offers": {
        "@type": "Offer",
        "url": "https://ariagreenhouse.com/products/3",
        "availability": "https://schema.org/InStock",
        "price": "85000",
        "priceCurrency": "IRR",
        "seller": {
          "@type": "Organization",
          "name": "آریا گرین هاوس"
        }
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.9",
        "reviewCount": "89"
      },
      "review": [
        {
          "@type": "Review",
          "reviewRating": {
            "@type": "Rating",
            "ratingValue": "5"
          },
          "author": {
            "@type": "Person",
            "name": "احمد محمدی"
          },
          "reviewBody": "نخ بسیار مقاوم و با کیفیت عالی برای گلخانه"
        }
      ],
      "sku": "UV-THREAD-001",
      "mpn": "UVTH2000",
      "gtin": "1234567890123"
    }
  };

  const productImages = [
    'https://readdy.ai/api/search-image?query=UV%20resistant%20greenhouse%20twine%20rope%20white%20color%20polypropylene%20material%20for%20plant%20support%20professional%20agricultural%20equipment%20clean%20white%20background%20product%20photography&width=600&height=600&seq=uv-thread-1&orientation=squarish',
    'https://readdy.ai/api/search-image?query=greenhouse%20twine%20rope%20being%20used%20to%20support%20tomato%20plants%20in%20modern%20greenhouse%20facility%20agricultural%20application%20UV%20resistant%20material&width=600&height=600&seq=uv-thread-2&orientation=squarish',
    'https://readdy.ai/api/search-image?query=green%20UV%20resistant%20greenhouse%20twine%20rope%20roll%20polypropylene%20material%20for%20plant%20support%20clean%20white%20background%20professional%20product%20photography&width=600&height=600&seq=uv-thread-3&orientation=squarish',
    'https://readdy.ai/api/search-image?query=greenhouse%20twine%20rope%20installation%20guide%20showing%20proper%20plant%20support%20technique%20cucumber%20and%20tomato%20plants%20modern%20greenhouse&width=600&height=600&seq=uv-thread-4&orientation=squarish'
  ];

  const tabs = [
    { id: 'overview', label: 'نمای کلی', icon: 'ri-eye-line' },
    { id: 'specifications', label: 'مشخصات فنی', icon: 'ri-settings-line' },
    { id: 'usage', label: 'راهنمای استفاده', icon: 'ri-book-line' },
    { id: 'applications', label: 'کاربردها', icon: 'ri-plant-line' },
    { id: 'benefits', label: 'مزایا', icon: 'ri-star-line' }
  ];

  return (
    <div className="min-h-screen">
      <SEOHead {...seoData} />
      <Header />
      
      {/* Hero Section */}
      <section className="relative h-96 flex items-center justify-center bg-cover bg-center pt-24 mt-20"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('https://readdy.ai/api/search-image?query=UV%20resistant%20greenhouse%20twine%20rope%20for%20plant%20support%20professional%20agricultural%20equipment%20white%20background%20modern%20product%20photography%20strong%20durable%20material&width=1920&height=600&seq=product3-hero&orientation=landscape')`
        }}
      >
        <div className="container mx-auto px-4 lg:px-8 text-center text-white">
          <h1 className="text-5xl lg:text-6xl font-bold mb-6">
            {t('product.uvThread.title')}
          </h1>
          <p className="text-xl lg:text-2xl max-w-3xl mx-auto">
            {t('product.uvThread.subtitle')}
          </p>
        </div>
      </section>

      {/* Product Content */}
      <section className="py-20">
        <div className="container mx-auto px-4 lg:px-8">
          {/* Product Images and Basic Info */}
          <div className="grid lg:grid-cols-2 gap-12 mb-16">
            {/* Product Images */}
            <div className="space-y-4">
              <div className="aspect-square bg-gray-100 rounded-lg overflow-hidden">
                <img 
                  src={productImages[0]} 
                  alt="نخ یووی دار گلخانه"
                  className="w-full h-full object-cover object-center"
                />
              </div>
              <div className="grid grid-cols-3 gap-4">
                {productImages.slice(1).map((image, index) => (
                  <div key={index} className="aspect-square bg-gray-100 rounded-lg overflow-hidden cursor-pointer hover:opacity-80 transition-opacity">
                    <img 
                      src={image} 
                      alt={`نخ یووی دار گلخانه ${index + 2}`}
                      className="w-full h-full object-cover object-center"
                    />
                  </div>
                ))}
              </div>
            </div>

            {/* Product Info */}
            <div className="space-y-6">
              <div>
                <h2 className="text-3xl font-bold text-gray-800 mb-4">
                  {t('product.uvThread.title')}
                </h2>
                <p className="text-lg text-gray-600 leading-relaxed">
                  {t('product.uvThread.description')}
                </p>
              </div>

              {/* Quick Specs */}
              <div className="bg-green-50 p-6 rounded-lg">
                <h3 className="text-xl font-semibold text-gray-800 mb-4">مشخصات کلیدی</h3>
                <div className="grid grid-cols-2 gap-4 text-sm">
                  <div>
                    <span className="font-medium text-gray-700">طول:</span>
                    <span className="text-gray-600 mr-2">{t('product.uvThread.specs.lengthValue')}</span>
                  </div>
                  <div>
                    <span className="font-medium text-gray-700">وزن:</span>
                    <span className="text-gray-600 mr-2">{t('product.uvThread.specs.weightValue')}</span>
                  </div>
                  <div>
                    <span className="font-medium text-gray-700">جنس:</span>
                    <span className="text-gray-600 mr-2">{t('product.uvThread.specs.materialValue')}</span>
                  </div>
                  <div>
                    <span className="font-medium text-gray-700">محافظت UV:</span>
                    <span className="text-gray-600 mr-2">{t('product.uvThread.specs.uvProtectionValue')}</span>
                  </div>
                </div>
              </div>

              {/* Availability */}
              <div className="flex items-center space-x-4 space-x-reverse">
                <div className="flex items-center">
                  <div className="w-3 h-3 bg-green-500 rounded-full ml-2"></div>
                  <span className="text-green-600 font-medium">{t('product.inStock')}</span>
                </div>
                <div className="text-sm text-gray-500">
                  رنگ‌های موجود: {t('product.uvThread.specs.colorsValue')}
                </div>
              </div>

              {/* CTA Buttons */}
              <div className="flex flex-col sm:flex-row gap-4">
                <button className="flex-1 bg-green-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-green-700 transition-colors whitespace-nowrap">
                  {t('btn.requestConsultation')}
                </button>
                <button className="flex-1 border border-green-600 text-green-600 px-6 py-3 rounded-lg font-medium hover:bg-green-50 transition-colors whitespace-nowrap">
                  {t('btn.getQuote')}
                </button>
              </div>
            </div>
          </div>

          {/* Product Details Tabs */}
          <div className="bg-white rounded-lg shadow-lg overflow-hidden">
            {/* Tab Navigation */}
            <div className="border-b border-gray-200">
              <nav className="flex overflow-x-auto">
                {tabs.map((tab) => (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`flex items-center px-6 py-4 text-sm font-medium whitespace-nowrap border-b-2 transition-colors ${
                      activeTab === tab.id
                        ? 'border-green-500 text-green-600'
                        : 'border-transparent text-gray-500 hover:text-gray-700'
                    }`}
                  >
                    <i className={`${tab.icon} ml-2`}></i>
                    {tab.label}
                  </button>
                ))}
              </nav>
            </div>

            {/* Tab Content */}
            <div className="p-8">
              {activeTab === 'overview' && (
                <div className="space-y-8">
                  <div>
                    <h3 className="text-2xl font-bold text-gray-800 mb-4">درباره محصول</h3>
                    <p className="text-gray-600 leading-relaxed mb-6">
                      {t('product.uvThread.description')}
                    </p>
                    <p className="text-gray-600 leading-relaxed">
                      این نخ با استفاده از بهترین مواد اولیه و تکنولوژی روز تولید شده و برای استفاده در گلخانه‌های مدرن طراحی شده است. مقاومت بالا در برابر اشعه UV و شرایط محیطی، آن را به انتخاب ایده‌آل برای کشاورزان حرفه‌ای تبدیل کرده است.
                    </p>
                  </div>

                  <div className="grid md:grid-cols-3 gap-6">
                    <div className="text-center p-6 bg-green-50 rounded-lg">
                      <i className="ri-shield-check-line text-3xl text-green-600 mb-4"></i>
                      <h4 className="font-semibold text-gray-800 mb-2">مقاوم در برابر UV</h4>
                      <p className="text-sm text-gray-600">محافظت ۴ درصدی در برابر اشعه ماورای بنفش</p>
                    </div>
                    <div className="text-center p-6 bg-blue-50 rounded-lg">
                      <i className="ri-weight-line text-3xl text-blue-600 mb-4"></i>
                      <h4 className="font-semibold text-gray-800 mb-2">مقاومت بالا</h4>
                      <p className="text-sm text-gray-600">قابلیت تحمل وزن تا ۱۵ کیلوگرم</p>
                    </div>
                    <div className="text-center p-6 bg-purple-50 rounded-lg">
                      <i className="ri-time-line text-3xl text-purple-600 mb-4"></i>
                      <h4 className="font-semibold text-gray-800 mb-2">دوام طولانی</h4>
                      <p className="text-sm text-gray-600">عمر مفید بالا در شرایط گلخانه‌ای</p>
                    </div>
                  </div>
                </div>
              )}

              {activeTab === 'specifications' && (
                <div className="space-y-6">
                  <h3 className="text-2xl font-bold text-gray-800 mb-6">{t('product.uvThread.specs.title')}</h3>
                  <div className="grid md:grid-cols-2 gap-8">
                    <div className="space-y-4">
                      <div className="flex justify-between py-3 border-b border-gray-200">
                        <span className="font-medium text-gray-700">{t('product.uvThread.specs.length')}</span>
                        <span className="text-gray-600">{t('product.uvThread.specs.lengthValue')}</span>
                      </div>
                      <div className="flex justify-between py-3 border-b border-gray-200">
                        <span className="font-medium text-gray-700">{t('product.uvThread.specs.weight')}</span>
                        <span className="text-gray-600">{t('product.uvThread.specs.weightValue')}</span>
                      </div>
                      <div className="flex justify-between py-3 border-b border-gray-200">
                        <span className="font-medium text-gray-700">{t('product.uvThread.specs.material')}</span>
                        <span className="text-gray-600">{t('product.uvThread.specs.materialValue')}</span>
                      </div>
                      <div className="flex justify-between py-3 border-b border-gray-200">
                        <span className="font-medium text-gray-700">{t('product.uvThread.specs.uvProtection')}</span>
                        <span className="text-gray-600">{t('product.uvThread.specs.uvProtectionValue')}</span>
                      </div>
                    </div>
                    <div className="space-y-4">
                      <div className="flex justify-between py-3 border-b border-gray-200">
                        <span className="font-medium text-gray-700">{t('product.uvThread.specs.type')}</span>
                        <span className="text-gray-600">{t('product.uvThread.specs.typeValue')}</span>
                      </div>
                      <div className="flex justify-between py-3 border-b border-gray-200">
                        <span className="font-medium text-gray-700">{t('product.uvThread.specs.colors')}</span>
                        <span className="text-gray-600">{t('product.uvThread.specs.colorsValue')}</span>
                      </div>
                      <div className="flex justify-between py-3 border-b border-gray-200">
                        <span className="font-medium text-gray-700">{t('product.uvThread.specs.manufacturer')}</span>
                        <span className="text-gray-600">{t('product.uvThread.specs.manufacturerValue')}</span>
                      </div>
                      <div className="flex justify-between py-3 border-b border-gray-200">
                        <span className="font-medium text-gray-700">ضمانت</span>
                        <span className="text-gray-600">۱ سال</span>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {activeTab === 'usage' && (
                <div className="space-y-8">
                  <h3 className="text-2xl font-bold text-gray-800 mb-6">{t('product.uvThread.installation.title')}</h3>
                  <div className="grid gap-6">
                    {[
                      {
                        step: '1',
                        title: t('product.uvThread.installation.step1'),
                        desc: t('product.uvThread.installation.step1Desc'),
                        icon: 'ri-tools-line'
                      },
                      {
                        step: '2',
                        title: t('product.uvThread.installation.step2'),
                        desc: t('product.uvThread.installation.step2Desc'),
                        icon: 'ri-map-pin-line'
                      },
                      {
                        step: '3',
                        title: t('product.uvThread.installation.step3'),
                        desc: t('product.uvThread.installation.step3Desc'),
                        icon: 'ri-arrow-up-line'
                      },
                      {
                        step: '4',
                        title: t('product.uvThread.installation.step4'),
                        desc: t('product.uvThread.installation.step4Desc'),
                        icon: 'ri-plant-line'
                      },
                      {
                        step: '5',
                        title: t('product.uvThread.installation.step5'),
                        desc: t('product.uvThread.installation.step5Desc'),
                        icon: 'ri-search-line'
                      }
                    ].map((item, index) => (
                      <div key={index} className="flex items-start space-x-4 space-x-reverse p-6 bg-gray-50 rounded-lg">
                        <div className="flex-shrink-0 w-12 h-12 bg-green-600 text-white rounded-full flex items-center justify-center font-bold">
                          {item.step}
                        </div>
                        <div className="flex-1">
                          <h4 className="text-lg font-semibold text-gray-800 mb-2 flex items-center">
                            <i className={`${item.icon} ml-2 text-green-600`}></i>
                            {item.title}
                          </h4>
                          <p className="text-gray-600">{item.desc}</p>
                        </div>
                      </div>
                    ))}
                  </div>

                  {/* Maintenance Section */}
                  <div className="mt-12">
                    <h4 className="text-xl font-bold text-gray-800 mb-6">{t('product.uvThread.maintenance.title')}</h4>
                    <div className="grid md:grid-cols-2 gap-6">
                      <div className="p-6 border border-gray-200 rounded-lg">
                        <h5 className="font-semibold text-gray-800 mb-2 flex items-center">
                          <i className="ri-brush-line ml-2 text-blue-600"></i>
                          {t('product.uvThread.maintenance.cleaning')}
                        </h5>
                        <p className="text-gray-600 text-sm">{t('product.uvThread.maintenance.cleaningDesc')}</p>
                      </div>
                      <div className="p-6 border border-gray-200 rounded-lg">
                        <h5 className="font-semibold text-gray-800 mb-2 flex items-center">
                          <i className="ri-search-eye-line ml-2 text-green-600"></i>
                          {t('product.uvThread.maintenance.inspection')}
                        </h5>
                        <p className="text-gray-600 text-sm">{t('product.uvThread.maintenance.inspectionDesc')}</p>
                      </div>
                      <div className="p-6 border border-gray-200 rounded-lg">
                        <h5 className="font-semibold text-gray-800 mb-2 flex items-center">
                          <i className="ri-refresh-line ml-2 text-orange-600"></i>
                          {t('product.uvThread.maintenance.replacement')}
                        </h5>
                        <p className="text-gray-600 text-sm">{t('product.uvThread.maintenance.replacementDesc')}</p>
                      </div>
                      <div className="p-6 border border-gray-200 rounded-lg">
                        <h5 className="font-semibold text-gray-800 mb-2 flex items-center">
                          <i className="ri-archive-line ml-2 text-purple-600"></i>
                          {t('product.uvThread.maintenance.storage')}
                        </h5>
                        <p className="text-gray-600 text-sm">{t('product.uvThread.maintenance.storageDesc')}</p>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {activeTab === 'applications' && (
                <div className="space-y-8">
                  <h3 className="text-2xl font-bold text-gray-800 mb-6">{t('product.uvThread.applications.title')}</h3>
                  <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {[
                      {
                        title: t('product.uvThread.applications.tomato'),
                        desc: t('product.uvThread.applications.tomatoDesc'),
                        icon: 'ri-plant-line',
                        color: 'red'
                      },
                      {
                        title: t('product.uvThread.applications.cucumber'),
                        desc: t('product.uvThread.applications.cucumberDesc'),
                        icon: 'ri-leaf-line',
                        color: 'green'
                      },
                      {
                        title: t('product.uvThread.applications.beans'),
                        desc: t('product.uvThread.applications.beansDesc'),
                        icon: 'ri-seedling-line',
                        color: 'yellow'
                      },
                      {
                        title: t('product.uvThread.applications.pepper'),
                        desc: t('product.uvThread.applications.pepperDesc'),
                        icon: 'ri-fire-line',
                        color: 'orange'
                      },
                      {
                        title: t('product.uvThread.applications.herbs'),
                        desc: t('product.uvThread.applications.herbsDesc'),
                        icon: 'ri-medicine-bottle-line',
                        color: 'purple'
                      },
                      {
                        title: t('product.uvThread.applications.flowers'),
                        desc: t('product.uvThread.applications.flowersDesc'),
                        icon: 'ri-flower-line',
                        color: 'pink'
                      }
                    ].map((app, index) => (
                      <div key={index} className="p-6 border border-gray-200 rounded-lg hover:shadow-md transition-shadow">
                        <div className={`w-12 h-12 bg-${app.color}-100 rounded-lg flex items-center justify-center mb-4`}>
                          <i className={`${app.icon} text-2xl text-${app.color}-600`}></i>
                        </div>
                        <h4 className="text-lg font-semibold text-gray-800 mb-2">{app.title}</h4>
                        <p className="text-gray-600 text-sm">{app.desc}</p>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {activeTab === 'benefits' && (
                <div className="space-y-8">
                  <h3 className="text-2xl font-bold text-gray-800 mb-6">{t('product.uvThread.features.title')}</h3>
                  <div className="grid md:grid-cols-2 gap-8">
                    {[
                      {
                        title: t('product.uvThread.features.uvResistant'),
                        desc: t('product.uvThread.features.uvResistantDesc'),
                        icon: 'ri-shield-check-line',
                        color: 'green'
                      },
                      {
                        title: t('product.uvThread.features.highStrength'),
                        desc: t('product.uvThread.features.highStrengthDesc'),
                        icon: 'ri-weight-line',
                        color: 'blue'
                      },
                      {
                        title: t('product.uvThread.features.weatherResistant'),
                        desc: t('product.uvThread.features.weatherResistantDesc'),
                        icon: 'ri-cloud-line',
                        color: 'indigo'
                      },
                      {
                        title: t('product.uvThread.features.easyInstall'),
                        desc: t('product.uvThread.features.easyInstallDesc'),
                        icon: 'ri-tools-line',
                        color: 'orange'
                      },
                      {
                        title: t('product.uvThread.features.longLasting'),
                        desc: t('product.uvThread.features.longLastingDesc'),
                        icon: 'ri-time-line',
                        color: 'purple'
                      },
                      {
                        title: t('product.uvThread.features.costEffective'),
                        desc: t('product.uvThread.features.costEffectiveDesc'),
                        icon: 'ri-money-dollar-circle-line',
                        color: 'yellow'
                      }
                    ].map((benefit, index) => (
                      <div key={index} className="flex items-start space-x-4 space-x-reverse p-6 bg-gray-50 rounded-lg">
                        <div className={`flex-shrink-0 w-12 h-12 bg-${benefit.color}-100 rounded-lg flex items-center justify-center`}>
                          <i className={`${benefit.icon} text-xl text-${benefit.color}-600`}></i>
                        </div>
                        <div className="flex-1">
                          <h4 className="text-lg font-semibold text-gray-800 mb-2">{benefit.title}</h4>
                          <p className="text-gray-600">{benefit.desc}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Related Products */}
          <div className="mt-16">
            <h3 className="text-2xl font-bold text-gray-800 mb-8 text-center">{t('product.uvThread.related.title')}</h3>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {[
                {
                  title: t('product.uvThread.related.clips'),
                  desc: t('product.uvThread.related.clipsDesc'),
                  image: 'https://readdy.ai/api/search-image?query=greenhouse%20plant%20clips%20holders%20for%20twine%20rope%20support%20plastic%20clips%20agricultural%20equipment%20white%20background%20product%20photography&width=300&height=300&seq=related-clips&orientation=squarish'
                },
                {
                  title: t('product.uvThread.related.hooks'),
                  desc: t('product.uvThread.related.hooksDesc'),
                  image: 'https://readdy.ai/api/search-image?query=greenhouse%20ceiling%20hooks%20for%20hanging%20twine%20rope%20metal%20hooks%20agricultural%20equipment%20white%20background%20product%20photography&width=300&height=300&seq=related-hooks&orientation=squarish'
                },
                {
                  title: t('product.uvThread.related.tensioners'),
                  desc: t('product.uvThread.related.tensionersDesc'),
                  image: 'https://readdy.ai/api/search-image?query=twine%20rope%20tensioner%20adjustment%20tool%20greenhouse%20equipment%20metal%20device%20white%20background%20product%20photography&width=300&height=300&seq=related-tensioners&orientation=squarish'
                },
                {
                  title: t('product.uvThread.related.supports'),
                  desc: t('product.uvThread.related.supportsDesc'),
                  image: 'https://readdy.ai/api/search-image?query=greenhouse%20support%20beams%20metal%20structure%20for%20plant%20support%20system%20agricultural%20equipment%20white%20background%20product%20photography&width=300&height=300&seq=related-supports&orientation=squarish'
                }
              ].map((product, index) => (
                <div key={index} className="bg-white border border-gray-200 rounded-lg overflow-hidden hover:shadow-md transition-shadow cursor-pointer">
                  <div className="aspect-square bg-gray-100">
                    <img 
                      src={product.image} 
                      alt={product.title}
                      className="w-full h-full object-cover object-center"
                    />
                  </div>
                  <div className="p-4">
                    <h4 className="font-semibold text-gray-800 mb-2">{product.title}</h4>
                    <p className="text-sm text-gray-600 mb-3">{product.desc}</p>
                    <button className="text-green-600 text-sm font-medium hover:text-green-700 transition-colors">
                      {t('btn.viewDetails')}
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* CTA Section */}
          <div className="mt-16 bg-green-600 text-white rounded-lg p-8 text-center">
            <h3 className="text-2xl font-bold mb-4">آماده سفارش نخ یووی دار گلخانه هستید؟</h3>
            <p className="text-lg mb-6 opacity-90">
              با کارشناسان ما تماس بگیرید و مشاوره رایگان دریافت کنید
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="bg-white text-green-600 px-8 py-3 rounded-lg font-medium hover:bg-gray-100 transition-colors whitespace-nowrap">
                {t('btn.contactExperts')}
              </button>
              <button className="border border-white text-white px-8 py-3 rounded-lg font-medium hover:bg-green-700 transition-colors whitespace-nowrap">
                {t('btn.getQuote')}
              </button>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <WhatsAppButton />
    </div>
  );
}
